
export function applicationSlot(): "blue" | "green" {
    const cookie = getCookie("slot");
    return cookie === "blue" ? "blue" : "green";

    function getCookie(name: string) {
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find(row => row.startsWith(name + '='));
        return cookie ? cookie.split('=')[1] : null;
    }
}